<template>
  <div style="width:100%">
    <div>
      <div
        class="b1"
        v-for="(item, index) in list"
        :key="index"
      >
        <p
          @click.stop="clickCompony(item)"
          v-if="item.companyName"
        >
          {{ item.companyName }}
          <i
            style="float:right;margin-right:30px;cursor: pointer;"
            class="el-icon-bottom"
            v-if="item.treeCompanies"
            @click.stop="$set(item, 'showNode', item.showNode ? false : true)"
          ></i>
        </p>
        <ThreeChild
          :list="item.treeCompanies"
          v-show="item.showNode"
        />
        <div v-if="item.subProjects && item.subProjects.length">
          <div
            class="b1"
            v-for="childS in item.subProjects"
            :key="childS.porjectName"
          >
            <p @click="clickProject(childS)">
              {{ childS.porjectName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThreeChild from '@/components/ThreeChild'
import { COMPANY_URL, PROJECT_URL } from "@/util/constant.js";
import {
  Api_login
} from "@/api/api";
// import { getStore } from '@/util/store'
const COMPANY_USER = 7; // 公司人员
const PROJECT_USER = 8; // 项目人员
const UNIT_USER = 9; // 参建单位人员
const THIRD_PART_USER = 10; // 第三方人员
const other_USER = 11; // 其他人员
export default {
  name: 'ThreeChild',
  components: {
    ThreeChild
  },
  props: ['list'],
  data() {
    return {
      showNode: false,
      userType: 0
    }
  },
  methods: {
    clickCompony(data) {
      const companyId = data.id
      const projectId = 0
      this.goToHome({ companyId: companyId, projectId: projectId })
      console.log(data)
    },
    clickProject(data) {
      const userId = this.$route.query.userId
      // const projectName = data.porjectName
      // const projectId = this.$route.query.projectId
      // 点击项目，projectID获取接口最新id重新赋值 2022/6/3
      const projectId = data.id
      // this.goToHome({ companyId: data.id, projectId: projectId })
      const userType = this.$route.query.userType
      this.loginForCompany({ projectId: projectId, userType: userType, userId: userId, companyId: data.companyId })

    },
    loginForCompany(data) {
      Api_login.loginForCompany({ projectId: data.projectId }).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          window.location.href = `${PROJECT_URL}?userId=${data.userId}&companyId=${data.companyId}&projectId=${data.projectId}&userType=${data.userType}`
        } else {
          this.$message({
            type: "error",
            message: result.errors,
          });
        }
      })
    },
    goToHome(data) {
      const userId = this.$route.query.userId
      // const projectName = this.$route.query.projectName
      this.userType = this.$route.query.userType * 1


      switch (this.userType) {
        case COMPANY_USER://  公司人员
          window.location.href = `${COMPANY_URL}?userId=${userId}&companyId=${data.companyId}&projectId=${data.projectId}&userType=${this.userType}`
          break;
        case PROJECT_USER://  项目人员
          window.location.href = `${PROJECT_URL}?userId=${userId}&companyId=${data.companyId}&projectId=${data.projectId}&userType=${this.userType}`
          break;
        case UNIT_USER://  参建单位人员
          // TODO 前端未开发
          break;
        case THIRD_PART_USER:// 第三方人员
          // TODO 前端未开发
          break;
        case other_USER:// 其他人员
          break;
        default:
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b1 {
  width: 95%;
  float: right;
}

.b1 p {
  width: 100%;
  margin: 10px 0;
  // padding-left: 20px;
  border: 1px solid white;
  float: right;
  background: #072158;
  padding: 10px;
  font-size: 24px;
}
</style>